import { Component, OnInit, Input } from '@angular/core';
import { Comment } from 'ng2-app/modules/comment/models/comment/comment.model';
import { Activity } from 'ng2-app/modules/activity/models/activity/activity.model';
import { CommentService } from 'ng2-app/modules/comment/models/comment/comment.service';
import { take } from 'rxjs/operators';
import { LenderUser } from 'app/models/dto/lender-user.model';

@Component({
    selector: 'borrower-activity-comment',
    templateUrl: './borrower-activity-comment.component.html',
    styleUrls: ['./borrower-activity-comment.component.scss'],
    standalone: false
})
export class BorrowerActivityCommentComponent implements OnInit {
    @Input() comment: Comment;
    @Input() user: LenderUser;
    @Input() activity: Activity;

    editing = false;

    constructor( private commentService: CommentService ) { }

    ngOnInit() {
    }

    delete() {
        this.commentService.delete(this.comment).pipe(take(1)).subscribe();
    }
}
